import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBold, faItalic, faUnderline, faSuperscript, faSubscript } from "@fortawesome/free-solid-svg-icons";

import StyleButton from "./style-button";

const INLINE_STYLES = [
    { label: "Bold", icon: <FontAwesomeIcon icon={faBold} />, style: "BOLD" },
    { label: "Italic", icon: <FontAwesomeIcon icon={faItalic} />, style: "ITALIC" },
    { label: "Underline", icon: <FontAwesomeIcon icon={faUnderline} />, style: "UNDERLINE" },
    { label: "Superscript", icon: <FontAwesomeIcon icon={faSuperscript} />, style: "SUPERSCRIPT" },
    { label: "Subscript", icon: <FontAwesomeIcon icon={faSubscript} />, style: "SUBSCRIPT" },
];

const InlineStyleControls = (props) => {
    const currentStyle = props.editorState.getCurrentInlineStyle();

    const buttons = INLINE_STYLES.map((type) => {
        return (
            <StyleButton
                key={type.label}
                active={currentStyle.has(type.style)}
                label={type.label}
                icon={type.icon}
                onToggle={props.onToggle}
                style={type.style}
            />
        );
    });

    return <div className="rich-text-control-group">{buttons}</div>;
};

export default InlineStyleControls;
